import React from "react";

/** "Sign in with Google" — matches the auth glass-card aesthetic. */
export default function GoogleSignInButton({ testId = "google-signin-btn", label = "Continue with Google" }) {
  const start = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS,
    // THIS BREAKS THE AUTH.
    const redirectUrl = window.location.origin + "/auth/callback";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };
  return (
    <button
      type="button"
      onClick={start}
      data-testid={testId}
      className="w-full h-11 rounded-full glass-input flex items-center justify-center gap-2 font-display font-bold text-sm hover:brightness-105 transition"
    >
      <svg width="18" height="18" viewBox="0 0 48 48" aria-hidden="true">
        <path fill="#FFC107" d="M43.6 20.5H42V20H24v8h11.3c-1.6 4.7-6.1 8-11.3 8-6.6 0-12-5.4-12-12s5.4-12 12-12c3 0 5.8 1.1 7.9 3l5.7-5.7C34.5 6.5 29.5 4.5 24 4.5 13.2 4.5 4.5 13.2 4.5 24S13.2 43.5 24 43.5 43.5 34.8 43.5 24c0-1.2-.1-2.3-.4-3.5z"/>
        <path fill="#FF3D00" d="M6.3 14.7l6.6 4.8c1.8-3.4 5.4-5.8 9.6-5.8 3 0 5.8 1.1 7.9 3l5.7-5.7C32 7.5 27 5.5 21.5 5.5 14 5.5 7.6 9.4 6.3 14.7z"/>
        <path fill="#4CAF50" d="M24 43.5c5.4 0 10.3-2.1 14-5.5l-6.5-5.3c-2 1.4-4.5 2.2-7.5 2.2-5.2 0-9.6-3.3-11.2-8l-6.6 5.1C8.5 39.5 15.6 43.5 24 43.5z"/>
        <path fill="#1976D2" d="M43.6 20.5H42V20H24v8h11.3c-.8 2.2-2.2 4-4 5.2l6.5 5.3C41.4 35.4 43.5 30.1 43.5 24c0-1.2-.1-2.3-.4-3.5z"/>
      </svg>
      {label}
    </button>
  );
}
